import { getDisplayName } from "helpers/getDisplayName";

export const getEmployeeDisplayName = (employee: {
  email: string;
  info: {
    firstName?: string | null;
    lastName?: string | null;
  };
}): string => {
  return getDisplayName(
    employee.info?.firstName,
    employee.info?.lastName,
    employee.email,
  );
};
